import React, { useCallback } from 'react';
import MuiLink from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import styled from '@material-ui/core/styles/styled';
import clsx from 'clsx';

import { BaseLinkClassKey, IBaseLinkProps } from './types';
import ROUTES from './routes';
import { currentEnvironment } from '../../environment/environment';
import { czLinkButtonStyles } from './cz/linkButton.style';
import { huLinkButtonStyles } from './hu/linkButton.style';

export const useLinkButtonStyles = (): ClassNameMap<BaseLinkClassKey> => {
  switch (currentEnvironment()) {
    case 'cz':
      return makeStyles((theme: Theme) => createStyles(czLinkButtonStyles(theme)))({});
    case 'hu':
      return makeStyles((theme: Theme) => createStyles(huLinkButtonStyles(theme)))({});
    default:
      throw new Error('LinkButtonComponent invalid enviroment');
  }
};

const LinkButtonComponent = (props: IBaseLinkProps): React.ReactElement<IBaseLinkProps> => {
  const { text, link, ...muiLinkClasses } = props.classes;

  const onClickHandler = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (props.onClick) {
        props.onClick();
      }
    },
    [props.onClick]
  );

  if (props.isFile) {
    return (
      <MuiLink key={props.text} classes={muiLinkClasses} component="button" variant={props.textVariant}>
        <Typography className={text} align={props.textAlign} onClick={onClickHandler}>
          {props.text}
        </Typography>
      </MuiLink>
    );
  }
  
  return props.isExternal ? (
    <a href={ROUTES[props.route]} target="_blank" rel="noopener noreferrer" className={link}>
      <MuiLink key={props.text} classes={muiLinkClasses} component="button" variant={props.textVariant}>
        <Typography className={text} align={props.textAlign}>
          {props.text}
        </Typography>
      </MuiLink>
    </a>
  ) : (
    <Link to={ROUTES[props.route]} className={link}>
      <MuiLink key={props.text} classes={muiLinkClasses} component="button" variant={props.textVariant}>
        <Typography className={text} align={props.textAlign} onClick={onClickHandler}>
          {props.text}
        </Typography>
      </MuiLink>
    </Link>
  );
};

export default LinkButtonComponent;
